import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetNotice, IGetNotices, INoticeParams } from '../models/homepageManagementHomeNotice.model';
import QueryString from 'qs';

const uri = '/mgmt/homepage-management/home-notice';

export const getNotices = (campusCode: string, params: INoticeParams): AxiosPromise<IGetNotices> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/${campusCode}?${qsParams}`);
};

export const getNotice = (campusCode: string, noticeCode: number): AxiosPromise<IGetNotice> => {
  return axios.get(`${uri}/${campusCode}/${noticeCode}`);
};

export const createNotice = (data: FormData): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateNotice = (campusCode: string, noticeCode: number, data: FormData): AxiosPromise => {
  return axios.put(`${uri}/${campusCode}/${noticeCode}`, data);
};

export const deleteNotice = (campusCode: string, noticeCode: number): AxiosPromise => {
  return axios.delete(`${uri}/${campusCode}/${noticeCode}`);
};
